/** The reasons a request was refused with, when the backend sent them as a list of strings (a DRF validation error). */
export function getApiErrorReasons(err: unknown): string[] {
  const body = (err as { body?: unknown })?.body

  return Array.isArray(body) ? body.filter((reason): reason is string => typeof reason === 'string') : []
}
